import { render } from "./ClearCharacterButton.vue?vue&type=template&id=5ec1abce"
import script from "./ClearCharacterButton.vue?vue&type=script&lang=js"
export * from "./ClearCharacterButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__